<template>
    <v-icon v-if="type == 'cash'" :size="size ? size : '25'">mdi-cash-100</v-icon>
    <v-icon v-else-if="type == 'card'" :size="size ? size : '25'">mdi-credit-card-outline</v-icon>
    <v-icon v-else-if="type == 'transfer'" :size="size ? size : '25'">mdi-bank-transfer</v-icon>
    <v-icon v-else-if="type == 'debit'" :size="size ? size : '25'">mdi-credit-card-chip-outline</v-icon>
    <v-icon v-else-if="type == 'mobile'" :size="size ? size : '25'">mdi-cellphone-text</v-icon>
    <v-icon v-else :size="size ? size : '25'">{{ icon }}</v-icon>
</template>

<script>
export default {
    data() {
        return {
            icon: null,
        };
    },
    props: ['type', 'size'],
    created() {
        if (!this.type)
            this.icon = 'mdi-cash-100';
    }
}
</script>
